import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class FaqV1 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    const faqs = [
      {
        category: "General",
        questions: [
          {
            question: "What is Atom Power, and what products do you offer?",
            answer:
              "Atom Power (Pvt) Ltd, based in Karachi, is transforming energy storage with locally assembled lithium-ion batteries. New facility with local sourcing & cell manufacturing launching Q2 2025. We offer solar batteries, solar inverters and are authorized distributors of Trina Solar. We are a Wavetec subsidiary.",
          },
          {
            question: "How can I purchase Atom Power products?",
            answer:
              "Contact us at sales@atom-power.com, or call us at +92 326 8314491",
          },
          {
            question:
              "Are your products compatible with existing solar systems?",
            answer: "Yes.",
          },
        ],
      },
      {
        category: "Battery-Related",
        questions: [
          {
            question: "What type of battery does Atom Power offer?",
            answer:
              "We provide LiFePO4 (Lithium Iron Phosphate) batteries with advanced Battery Management Systems (BMS) for safety and efficiency.",
          },
          {
            question:
              "What is the capacity of Atom Power lithium-ion batteries?",
            answer:
              "Our Power Wall battery has a 5.12 kWh capacity, with usable storage of 4.6 kWh.",
          },
          {
            question: "What is the lifespan of the battery?",
            answer: "The battery lasts over 6000 cycles at 0.5C discharge.",
          },
          {
            question: "What are the charging and discharging rates?",
            answer: "Recommended: 50A\nMaximum: 100A",
          },
          {
            question: "What is the Depth of Discharge (DoD)?",
            answer:
              "Depth of discharge (DoD) indicates the percentage of the battery that has been discharged relative to the overall capacity of the battery. Atom batteries offer up to 90%, meaning you can use more of the battery’s capacity without reducing its lifespan.",
          },
          {
            question: "What are the operating temperature limits?",
            answer: "The battery functions between -10°C to 50°C.",
          },
          {
            question: "Is the battery maintenance-free?",
            answer:
              "Yes! Unlike lead-acid batteries, our lithium-ion battery requires zero maintenance.",
          },
          {
            question: "Does the battery support remote monitoring?",
            answer:
              "Yes, the battery has Wi-Fi, CAN, and RS485 connectivity for remote monitoring via the mobile app and web portal.",
          },
          {
            question: "How is the battery installed?",
            answer:
              "The battery can be wall-mounted or placed on a flat, stable surface.",
          },
          {
            question:
              "Can I connect multiple batteries for increased capacity?",
            answer:
              "Yes! You can parallel-connect multiple batteries for greater energy storage.",
          },
          {
            question: "Does the battery work with all inverters?",
            answer: "It is compatible with most modern solar inverters.",
          },
          {
            question: "How do I connect the battery to an inverter?",
            answer:
              "The battery connects via DC power terminals, and RS485/CAN ports enable communication with inverters.",
          },
          {
            question: "Why is my battery not charging?",
            answer:
              "Check if the circuit breaker is ON and the power button is pressed.",
          },
          {
            question: "What should I do if the circuit breaker keeps tripping?",
            answer:
              "Ensure there are no short circuits in the wiring. If the issue persists, check the inverter.",
          },
          {
            question: "What happens if my battery overheats?",
            answer:
              "The Battery Management System (BMS) automatically shuts down the battery in case of overheating.",
          },
          {
            question: "Is the battery safe to use indoors?",
            answer:
              "Yes! It is designed to be safe, quiet, and environmentally friendly.",
          },
        ],
      },
      {
        category: "Solar Inverter-Related",
        questions: [
          {
            question: "What types of solar inverters does Atom Power offer?",
            answer:
              "We offer Hybrid Solar Inverters in 6kW, 10kW, and 12kW capacities.",
          },
          {
            question: "Can the inverter be used without batteries?",
            answer:
              "Yes! Our hybrid inverters can work with or without battery storage.",
          },
          {
            question: "What protection features do the inverters have?",
            answer:
              "Our inverters include overvoltage, short circuit, and surge protection.",
          },
          {
            question:
              "Are Atom Power inverters compatible with all battery brands?",
            answer:
              "Our inverters work best with Atom Power batteries but are compatible with most LiFePO4 batteries.",
          },
          {
            question: "Can I monitor the inverter remotely?",
            answer:
              "Yes! Our inverters come with Wi-Fi connectivity for remote monitoring.",
          },
          {
            question: "Why is my inverter not turning on?",
            answer:
              "Check the circuit breaker, battery connection, and power button.",
          },
          {
            question: "Why is my inverter not charging the battery?",
            answer:
              "Ensure that the inverter is properly configured for LiFePO4 batteries and that the battery is connected correctly.",
          },
          {
            question: "What should I do if my inverter shows a fault code?",
            answer:
              "Refer to the user manual or contact Atom Power support for troubleshooting.",
          },
        ],
      },
      {
        category: "Warranty & Support",
        questions: [
          {
            question: "What is the warranty period for Atom Power batteries?",
            answer: "5 years total (1-year replacement + 4-year repair).",
          },
          {
            question: "What is the warranty for Atom Power inverters?",
            answer: "5 years total (1-year replacement + 4-year repair).",
          },
          {
            question: "What is covered under the battery warranty?",
            answer:
              "Manufacturing defects, performance issues, and premature failure.",
          },
          {
            question: "What is NOT covered under the warranty?",
            answer:
              "Physical damage, improper installation, and exceeding the recommended charge cycles.",
          },
          {
            question: "How do I file a warranty claim?",
            answer: "Contact sales@atom-power.com or call +92-326-8314491.",
          },
        ],
      },
      {
        category: "Technical Support & After-Sales Service",
        questions: [
          {
            question: "How can I get technical support?",
            answer:
              "Reach us at sales@atom-power.com or visit www.atom-power.com.",
          },
          {
            question: "Can I upgrade my system in the future?",
            answer:
              "Yes! Our system is modular, so you can add more batteries or a larger inverter.",
          },
        ],
      },
    ];

    return (
      <div className="ltn__faq-area mb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__faq-inner ltn__faq-inner-2">
                {faqs.map((section, secIndex) => (
                  <div key={secIndex}>
                    <h3 className="mb-4 mt-4">{section.category}</h3>
                    <div id={`accordion_${secIndex}`}>
                      {section.questions.map((item, index) => (
                        <div className="card" key={index}>
                          <h6
                            className="collapsed ltn__card-title"
                            data-bs-toggle="collapse"
                            data-bs-target={`#faq-item-${secIndex}-${index}`}
                            aria-expanded="false"
                          >
                            {item.question}
                          </h6>
                          <div
                            id={`faq-item-${secIndex}-${index}`}
                            className="collapse"
                            data-bs-parent={`#accordion_${secIndex}`}
                          >
                            <div className="card-body">
                              <p>{item.answer}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}

                {/* <div className="need-support text-center mt-100">
                  <h2>Still need help? Reach out to support 24/7:</h2>
                  <div className="btn-wrapper mb-30 go-top">
                    <Link to="/contact" className="theme-btn-1 btn">
                      Contact Us
                    </Link>
                  </div>
                  <h3>
                    <i className="fas fa-phone" /> +0123-456-789
                  </h3>
                </div> */}
              </div>
            </div>

            {/* Col - 2 */}
            {/* <div className="col-lg-4">
                <aside className="sidebar-area ltn__right-sidebar">
                    <div className="widget ltn__search-widget ltn__newsletter-widget">                            
                    <h6 className="ltn__widget-sub-title">// subscribe</h6>
                    <h4 className="ltn__widget-title">Get Newsletter</h4>
                    <form action="#">
                        <input type="text" name="search" placeholder="Search" />
                        <button type="submit"><i className="fas fa-search" /></button>
                    </form>
                    <div className="ltn__newsletter-bg-icon">
                        <i className="fas fa-envelope-open-text" />
                    </div>
                    </div>
                    <div className="widget ltn__banner-widget go-top">
                    <Link to="shop.html"><img src={publicUrl+"assets/img/banner/banner-3.jpg"} alt="Banner Image" /></Link>
                    </div>
                </aside>
                </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default FaqV1;
